__turbopack_context__.v({
  "container": "_4G9nZG_container",
  "content": "_4G9nZG_content",
  "list": "_4G9nZG_list",
  "loop": "_4G9nZG_loop",
  "looping": "_4G9nZG_looping",
  "play-button": "_4G9nZG_play-button",
  "playing": "_4G9nZG_playing",
  "view": "_4G9nZG_view",
});
